import type { ListBuilderConfiguration } from '../../types';
import { allTransactionsList } from './lists/all-transactions';
import { failedTransactionsList } from './lists/failed-transactions';
import { processingTransactionsList } from './lists/pending-transactions';
import { refundTransactionsList } from './lists/refund-transactions';
import { thisWeekTransactionsList } from './lists/this-week-transactions';
import { todaysTransactionsList } from './lists/todays-transactions';
import { voidedTransactionsList } from './lists/voided-transactions';

/**
 * Transaction summary list configuration
 * Lists: All, Failed, Today's, This Week, Pending, Refunds, Voided
 */
export const TRANSACTION_SUMMARY_LIST_CONFIG: ListBuilderConfiguration = {
	lists: [
		allTransactionsList,
		failedTransactionsList,
		todaysTransactionsList,
		thisWeekTransactionsList,
		processingTransactionsList,
		refundTransactionsList,
		voidedTransactionsList,
	],
	paging: {
		defaultPageSize: 20,
		pageSizeOptions: [20, 50, 100],
	},
	showResetButton: true,
	filters: {
		activeFilters: [
			'transactionKeywords',
			'paymentDateRange',
			'transactionStatus',
			'transactionOrigin',
			'transactionType',
		],
		defaultFilters: {},
	},
	objects: [
		{
			baseUrl: '/transactions/:id',
			objectLabel: 'Transaction',
			objectTable: 'transaction_summary',
			selectedFields: [
				{ fieldName: '_id', fieldLabel: 'ID' },
				{ fieldName: '_created_date', fieldLabel: 'Created Date' },
				{ fieldName: '_modified_date', fieldLabel: 'Modified Date' },
				{ fieldName: 'm_sm_payment_externalId', fieldLabel: 'Processor ID' },
				{ fieldName: 'm_payment_externalId_erp', fieldLabel: 'ERP ID' },
				{ fieldName: 'm_sm_payment_amount', fieldLabel: 'Payment Amount' },
				{ fieldName: 'm_payment_netAmount', fieldLabel: 'Net Amount' },
				{ fieldName: 'm_payment_status', fieldLabel: 'Status' },
				{ fieldName: 'm_payment_origin', fieldLabel: 'Origin' },
				{ fieldName: 'm_payment_datetime', fieldLabel: 'Payment Date' },
				{
					fieldName: 'm_payment_payment_method_subtype',
					fieldLabel: 'Payment Method Subtype',
				},
				{
					fieldName: 'm_payment_payment_method_lastFour',
					fieldLabel: 'Payment Method Last Four',
				},
				{
					fieldName: 'm_payment_payment_method_type',
					fieldLabel: 'Payment Method Type',
				},
				{
					fieldName: 'm_payment_payment_method_name',
					fieldLabel: 'Payment Method Name',
				},
				{ fieldName: 'm_payment_checkNumber', fieldLabel: 'Check Number' },
				{ fieldName: 'transactionType', fieldLabel: 'Transaction Type' },
				{ fieldName: 'referenceNumber', fieldLabel: 'Reference Number' },
				{ fieldName: 'clientName', fieldLabel: 'Client Name' },
				{ fieldName: 'clientId', fieldLabel: 'Client ID' },
				{ fieldName: 'clientAddress', fieldLabel: 'Client Address' },
				{ fieldName: 'clientCity', fieldLabel: 'Client City' },
				{ fieldName: 'clientState', fieldLabel: 'Client State' },
				{ fieldName: 'clientZipCode', fieldLabel: 'Client Zip Code' },
				{ fieldName: 'invoiceId', fieldLabel: 'Invoice ID' },
				{ fieldName: 'orderId', fieldLabel: 'Order ID' },
			],
		},
		{
			baseUrl: '/clients/:id',
			objectLabel: 'Client',
			objectTable: 'client',
			selectedFields: [
				{ fieldName: '_id', fieldLabel: 'ID' },
				{ fieldName: 'name', fieldLabel: 'Name' },
			],
		},
	],
	tableSorts: [
		{
			id: 'date-desc',
			name: 'Date (Newest First)',
			fields: [
				{
					direction: 'DESC',
					fieldName: 'm_payment_datetime',
					objectTable: 'transaction_summary',
				},
			],
			description: 'Sort transactions by date, newest first',
		},
		{
			id: 'date-asc',
			name: 'Date (Oldest First)',
			fields: [
				{
					direction: 'ASC',
					fieldName: 'm_payment_datetime',
					objectTable: 'transaction_summary',
				},
			],
			description: 'Sort transactions by date, oldest first',
		},
		{
			id: 'amount-desc',
			name: 'Amount (Highest First)',
			fields: [
				{
					direction: 'DESC',
					fieldName: 'm_sm_payment_amount',
					objectTable: 'transaction_summary',
				},
			],
			description: 'Sort transactions by amount, highest first',
		},
		{
			id: 'client-name',
			name: 'Client Name',
			fields: [
				{
					direction: 'ASC',
					fieldName: 'clientName',
					objectTable: 'transaction_summary',
				},
			],
			description: 'Sort transactions by client name',
		},
		{
			id: 'status',
			name: 'Status',
			fields: [
				{
					direction: 'ASC',
					fieldName: 'm_payment_status',
					objectTable: 'transaction_summary',
				},
			],
			description: 'Sort transactions by status',
		},
	],
};
